/*!
 * JS for jp-sp plc-inspection (see KAWASAKI_ROBO-749) and duaro-2 (see KAWASAKI_ROBO_KHI-220 )
 *
 * @deps jquery,jquery.matchHeight-min
 */

const $ = jQuery;
$( function() {
	/* -----------------------------------------------------
	ヘッダー
	----------------------------------------------------- */
	$( '.header_btn' ).on( 'click', function() {
		if ( $( this ).hasClass( 'active' ) ) {
			// メニュー閉じる
			$( this ).removeClass( 'active' );
			$( 'body' ).removeClass( 'active' );
			$( '.global_nav' ).removeClass( 'active' );
		} else {
			// メニュー開く
			$( this ).addClass( 'active' );
			$( 'body' ).addClass( 'active' );
			$( '.global_nav' ).addClass( 'active' );
		}
	} );
	// メニュー内のリンクをクリックで閉じる
	$( '.global_nav a' ).on( 'click', function() {
		$( '.header_btn' ).removeClass( 'active' );
		$( 'body' ).removeClass( 'active' );
		$( '.global_nav' ).removeClass( 'active' );
	} );

	/* -----------------------------------------------------
	ページ内リンク
	----------------------------------------------------- */
	$( 'a[href^="#"]' ).on( 'click', function( event ) {
		event.preventDefault();
		const target = $( this.getAttribute( 'href' ) );
		if ( target.length ) {
			$( 'html, body' ).animate( { scrollTop: target.offset().top }, 800 );
		}
	} );

	/* -----------------------------------------------------
	高さ合わせ
	----------------------------------------------------- */
	const tgtSelectors = [ '.height-adjustment h3' ];
	tgtSelectors.forEach( function( tgtSelector ) {
		$( tgtSelector ).matchHeight();
	} );

	// $(".flow_content_cards .card").matchHeight();
	$( '.case_content .column_2__block' ).matchHeight();
} );

